<template>
    <div class="table-wrapper table-responsive">
        <table class="table table-striped table-hover">
            <thead>
            <tr>
                <slot name="header"></slot>
            </tr>
            </thead>

            <tbody>
            <slot name="body"></slot>
            </tbody>
        </table>

        <v-pagination :meta="meta" :pagination="pagination"
                      @pageChanged="pageChanged"></v-pagination>
    </div>
</template>

<script>
import VPagination from "../general/VPagination";

export default {
    name: 'VTable',
    props: {
        meta: {
            type: Object,
            required: false,
        },
        pagination: {
            type: Object,
            required: false,
        },
    },
    components: {VPagination},
    methods: {
        async pageChanged(page) {
            this.$emit('pageChanged', page);
        },
    },
};
</script>
